export function getVistaHostKey(): string {
    return process.env.NEXT_PUBLIC_USE_STAGING === 'true' ||
        (typeof window !== 'undefined' && window.location.hostname.includes('staging'))
        ? 'staging.vistaprint.com'
        : 'vistaprint.com';
}
